import React from 'react';

/**
 * Skeleton loader for message/content lists
 * Shows animated placeholder rows while data is loading
 */
export const ContentSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => {
  return (
    <div className="animate-pulse space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-4 p-4 bg-vb-surface dark:bg-vb-surface-dark rounded-lg border border-vb-border dark:border-vb-border-dark"
        >
          <div className="h-10 w-10 bg-vb-surface-hover dark:bg-vb-surface-hover-dark rounded-full flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-4 w-3/4 bg-vb-surface-hover dark:bg-vb-surface-hover-dark rounded" />
            <div className="h-3 w-1/2 bg-vb-surface-hover dark:bg-vb-surface-hover-dark rounded" />
          </div>
          <div className="h-8 w-16 bg-vb-surface-hover dark:bg-vb-surface-hover-dark rounded flex-shrink-0" />
        </div>
      ))}
    </div>
  );
};

export default ContentSkeleton;
